<form [formGroup]="form">
	<div class="outsourced-processes-selector">
		<h5>{{ 'additional-questions.outsources-processes.question' | translate }}</h5>
		<div class="outsourced-processes-checkboxes">
			@for (process of predefinedOutsourcedProcessesKeys; track process; let i = $index) {
				<nb-checkbox [disabled]="shouldDisableControl(getRadioControlName(i)) || blocked" [checked]="isSelected(process)" [formControlName]="getRadioControlName(i)"
							 [attr.formcontrolname]="getRadioControlName(i)"
							 [attr.data-test-id]="'checkbox-outsource-process-' + process + '-' + product.standard.name"
							 [status]="(shouldDisplayValidationMsgForCheckboxes() | async) ? 'danger': 'primary'">{{ getTranslationKey(process) | translate }}
				</nb-checkbox>
			}

			<nb-checkbox [disabled]="shouldDisableControl('customOutsourcedProcess') || blocked" [checked]="customOutsourcedProcessChecked()"
						 [formControlName]="'customOutsourcedProcess' + product.standard.name" [attr.formcontrolname]="'customOutsourcedProcess' + product.standard.name"
						 [attr.data-test-id]="'checkbox-outsource-process-custom-' + product.standard.name"
						 [status]="(shouldDisplayValidationMsgForCheckboxes() | async) ? 'danger' : 'primary'">{{ 'additional-questions.outsources-processes.other' | translate }}
			</nb-checkbox>

		</div>
		@if (shouldDisplayValidationMsgForCheckboxes() | async) {
			<div class="validation-message">{{ 'validations.required' | translate }}</div>
		}
	</div>

	@if (customProcessCheckboxSelected) {
		<div>
			<text-area [form]="form" [formService]="formService" [autoGrowEnabled]="true" [controlName]="getCustomProcessTextAreaControlName()" [formKey]="product.standard.name"
					   [placeholder]="'additional-questions.outsources-processes.custom-op-placeholder' | translate" [htmlPrefix]="getCustomProcessTextAreaControlName()"
					   [dataTestId]="'additional-questions.outsources-processes.custom_' + product.standard.name"></text-area>
			@if (translationExists()) {
				<translation-field [previewMode]="true" [translatedText]="translatedOutsourcedProcess()"></translation-field>
			}
		</div>
	}
</form>
